import { useSyncExternalStore } from 'react';
import RoomStateStore, { roomStateChanged } from '../RoomState';
import type { RoomData } from '../messages';

// Snapshot for useSyncExternalStore
type RoomHandler = (room: RoomData | null) => void;
let snapshot: RoomData | null = null;

roomStateChanged.subscribe(((room: RoomData | null) => {
  snapshot = room ? { ...room } : null;
}) as RoomHandler);

function subscribe(callback: () => void): () => void {
  const handler: RoomHandler = () => callback();
  roomStateChanged.subscribe(handler);
  return () => roomStateChanged.unsubscribe(handler);
}

function getSnapshot(): RoomData | null {
  return snapshot ?? RoomStateStore.room;
}

export function useRoom() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function useRoomCode(): string | null {
  const room = useRoom();
  return room?.code ?? null;
}

export function useRoomState() {
  const room = useRoom();
  return room?.state ?? null;
}

export function useRoomPlayers() {
  const room = useRoom();
  return room?.players ?? [];
}

export function useCurrentSong() {
  const room = useRoom();
  return room?.currentSong ?? null;
}

export function useSongQueue() {
  const room = useRoom();
  return room?.songQueue ?? [];
}
